import React from 'react';
import styled from 'styled-components';
import {
  Border,
  Box,
  Center,
  Flex,
  Overlay,
  Padding,
  Queue,
  Stack,
  Text,
  Quote,
} from '../../components';

const CoreValuesMissionWrapper = styled.div<any>`
  position: relative;
`;

export const CoreValuesMissionTablet = () => {
  return (
    <>
      <CoreValuesMissionWrapper>
        <Queue>
          <Box ratio={0.9} backgroundImage="images/about-glossier-1.jpg" />
          <Box ratio={0.9} backgroundImage="images/about-glossier-2.jpg" />
        </Queue>
        <Overlay top={0} height="100%" width="100%">
          <Center>
            <Padding size={[0, 10]}>
              <Border borderSize={[2]} borderRole="white" radius="small">
                <Padding size={[5]} backgroundRole="white">
                  <Stack size={6}>
                    <Quote textType="quote" align="left">
                      Glossier is giving voice through beauty as a
                      direct-to-consumer company that leverages the power of
                      personal narrative to own the beauty conversation on the
                      internet.
                    </Quote>

                    <Text textType="primary2" align="left">
                      As a brand that puts skin first, Glossier is redefining
                      the beauty industry by fusing the insights of our
                      community with our beauty-editor expertise (rooted in
                      Glossier’s successful publication Into The Gloss) to
                      create a line of intuitive, enjoyable products that work
                      hard for you (not the other way around). Together, we’re
                      bringing the experience of shopping for (and talking
                      about) beauty into the future.
                    </Text>
                  </Stack>
                </Padding>
              </Border>
            </Padding>
          </Center>
        </Overlay>
      </CoreValuesMissionWrapper>
    </>
  );
};
